import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/roster',
		children: [
			{
				path: '',
				name: 'Roster',
				component: () => import('@/views/RosterIndex.vue'),
				meta: {
					layout: 'LayoutAuthenticated',
					requiresAuth: true,
					title: 'pageRoster.metaTitle',
					requiredAccess: 'hasTeamManagementRead',
				},
			},
		],
	},
];

export default routes;
